import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {年月書式, 必須入力} from '@/type/validation/validator';
import {渓仁会入出庫集計検索依頼型} from '@/type/custom/keijinkai/receiveandreturns';

export default class 渓仁会入出庫集計検索条件チェッカー {
  単項目チェック結果: Error[];

  constructor(target: 渓仁会入出庫集計検索依頼型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.map((value) => `${value.message}`);
  }
}

const 単項目チェックvalidators: Validator[] = [
  {
    name: '在庫年月',
    constraints: [
      {method: 必須入力, message: '在庫年月を入力してください'},
      {method: 年月書式, message: '在庫年月の書式が不正です'},
    ],
  },
];
